import { styled } from "baseui";

export const ModalBodyWrapper = styled("div", ({ $theme }) => ({
  paddingLeft: $theme.sizing.scale600,
}));
